export const products = {
  FLY: 'Flight',
  STAY: 'Hotel',
  DRIVE: 'Car',
  PACKAGE: 'Package'
};
export const productsType = {
  FLY: 'FLY',
  STAY: 'STAY',
  DRIVE: 'DRIVE',
  PACKAGE: 'PACKAGE'
};
export const mapPinType = {
  HOTEL: 'HOTEL',
  POI: 'POI',
  AIRPORT: 'AIRPORT',
  RESTAURANT: 'RESTAURANT'
};